import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useMessageContext } from 'components/Message/CreateMessageComponent/MessageContext';
import AiCreation from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiCreation';
import ContentPreview from 'components/Message/CreateMessageComponent/StepMessage/ContentPreview/ContentPreview';
import ManualCreation from 'components/Message/CreateMessageComponent/StepMessage/ManualCreation/ManualCreation';
import { useMessageService } from 'components/Message/useMessageService';
import { useState } from 'react';
import './StepMessage.css';

type AllProps = {
  initContent?: string;
  initTitle?: string;
  onNext: (shouldExit?: boolean) => void;
  onBack: () => void;
  goToDeliveryInfo: () => void;
};

function StepMessage({ initContent, initTitle, onBack, onNext, goToDeliveryInfo }: AllProps) {
  const { message } = useMessageService();
  const [type, setType] = useState<'manual' | 'ai'>();
  const { content, file } = useMessageContext();

  if (!message) return null;

  return (
    <div className="step-message create-message-component-full-height">
      {message.content || message.fileName || file || content ? (
        <ContentPreview
          message={message}
          file={file}
          text={content || message.content}
          onNext={onNext}
          onBack={onBack}
          onRestart={() => {
            setType(undefined);
          }}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      ) : type === 'ai' ? (
        <AiCreation
          initContent={initContent}
          onBack={() => setType(undefined)}
          onNext={onNext}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      ) : type === 'manual' ? (
        <ManualCreation
          initContent={initContent}
          initTitle={initTitle}
          onBack={() => setType(undefined)}
          onNext={onNext}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      ) : (
        <>
          <div>
            <div className="create-message-component-title">Want a little help, or ready to write on your own?</div>
            <div className="create-message-component-subtitle">
              Follow gentle prompts to shape your message, or start writing on your own.
            </div>

            <Row gutter={[20, 10]} className="step-message-row">
              <Col xs={24} lg={12} className="step-message-col">
                <div className="step-message-option">
                  <h3>Manual</h3>
                  <p>Write or record it yourself—text, audio, or video recording.</p>
                  <Button type="primary" size="large" onClick={() => setType('manual')}>
                    Start manual
                  </Button>
                </div>
              </Col>
              <Col xs={24} lg={12} className="step-message-col">
                <div className="step-message-option">
                  <h3>Prompted</h3>
                  <p>Answer a few prompts; we'll draft it for you to edit and refine.</p>
                  <Button type="primary" size="large" onClick={() => setType('ai')}>
                    Start answering prompts
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <Row className="create-message-component-footer">
            <Col span={12}>
              <Button onClick={onBack} type="link">
                <ArrowLeftOutlined /> Back
              </Button>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default StepMessage;
